module.exports = __webpack_public_path__ + "static/media/facebook.5715856c.png";